import { Box, Typography, styled } from '@mui/material';
import color from 'src/theme/color';

export const PlanTitle = styled(Typography)`
    font:
        600 16px/19px 'Inter',
        sans-serif;
    color: ${color.white90};
    margin-bottom: 12px;
`;

export const PlanContainer = styled(Box)<{ collapsed?: boolean }>`
    margin-top: 8px;
    width: 100%;
    box-sizing: border-box;
    background-color: ${color.blackRock};
    border-radius: 8px;
    padding: 24px;
    position: relative;
    ${({ collapsed }) =>
        collapsed &&
        `
        max-height: 320px;
        overflow: hidden;
        mask-image: linear-gradient(to bottom, black 60%, transparent 100%);
        -webkit-mask-image: linear-gradient(to bottom, black 60%, transparent 100%);
    `}
`;

export const PlanExpandToggle = styled(Box)`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px 0 0;
    cursor: pointer;
    color: ${color.lightningYellow};
    font-family: 'Inter', sans-serif;
    font-size: 13px;
    font-weight: 500;
    gap: 4px;
    &:hover {
        opacity: 0.8;
    }
`;
